import React from 'react';
import { Section, FadeIn } from './ui';
import { CheckCircle2Icon, GripVerticalIcon, PlusIcon } from 'lucide-react';
export function IntelligenceEngine() {
  const features = ['leadership and team-alignment modules', 'wellness and energy prompts', 'group discussion guides', 'pair and small-group exercises', 'reflection questions', 'post-event accountability prompts', 'client-ready learning summaries'];
  const modules = [{
    name: 'Leadership Reset',
    color: 'bg-brand-navy',
    text: 'text-white'
  }, {
    name: 'Team Trust',
    color: 'bg-brand-teal',
    text: 'text-white'
  }, {
    name: 'Communication Under Pressure',
    color: 'bg-slate-100',
    text: 'text-slate-700'
  }, {
    name: 'Wellness and Energy',
    color: 'bg-brand-coral',
    text: 'text-white'
  }, {
    name: 'Habits and Execution',
    color: 'bg-slate-100',
    text: 'text-slate-700'
  }, {
    name: 'Customer Excellence',
    color: 'bg-slate-100',
    text: 'text-slate-700'
  }, {
    name: 'Strategic Clarity',
    color: 'bg-slate-100',
    text: 'text-slate-700'
  }];
  return <Section className="bg-slate-50 overflow-hidden" data-id="element-4423">
      <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-4424">
        {/* Left: Copy */}
        <div data-id="element-4425">
          <FadeIn data-id="element-4426">
            <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-4427">
              Personalized learning pathways, built from proven ideas.
            </h2>
            <p className="text-lg text-slate-600 mb-8" data-id="element-4428">
              The Offsite+ Intelligence Engine blends AI, bestselling leadership
              and wellness frameworks, and executive-education style thinking to
              create curated learning pathways for every offsite.
            </p>
            <ul className="space-y-4" data-id="element-4429">
              {features.map((feature, i) => <li key={i} className="flex items-start gap-3" data-id="element-4430">
                  <CheckCircle2Icon className="w-6 h-6 text-brand-teal shrink-0" data-id="element-4431" />
                  <span className="text-slate-700 font-medium" data-id="element-4432">{feature}</span>
                </li>)}
            </ul>
          </FadeIn>
        </div>

        {/* Right: Module Builder Visual */}
        <FadeIn delay={0.2} className="relative" data-id="element-4433">
          <div className="absolute inset-0 bg-brand-coral/5 rounded-full blur-3xl" data-id="element-4434" />

          <div className="relative bg-white rounded-2xl shadow-soft border border-slate-100 p-6 md:p-8" data-id="element-4435">
            <div className="flex items-center justify-between mb-6 pb-4 border-b border-slate-100" data-id="element-4436">
              <div data-id="element-4437">
                <h3 className="font-bold text-brand-navy" data-id="element-4438">Pathway Builder</h3>
                <p className="text-xs text-slate-500" data-id="element-4439">
                  Drag to reorder modules
                </p>
              </div>
              <button className="bg-slate-100 p-2 rounded-lg text-slate-600 hover:bg-slate-200 transition-colors" data-id="element-4440">
                <PlusIcon className="w-5 h-5" data-id="element-4441" />
              </button>
            </div>

            <div className="space-y-3" data-id="element-4442">
              {modules.map((mod, i) => <div key={i} className={`flex items-center gap-3 p-3 rounded-xl border border-slate-100 shadow-sm transition-transform hover:-translate-y-0.5 cursor-grab ${mod.color} ${mod.text}`} data-id="element-4443">
                  <GripVerticalIcon className={`w-5 h-5 opacity-50 ${mod.text === 'text-white' ? 'text-white' : 'text-slate-400'}`} data-id="element-4444" />
                  <span className="font-semibold text-sm" data-id="element-4445">{mod.name}</span>
                </div>)}
            </div>
          </div>
        </FadeIn>
      </div>
    </Section>;
}